import React, { useRef } from "react"
// reactstrap components
import {
    Card,
    CardHeader,
    CardBody,
    Container,
    Row,
    Col,
    Button
} from "reactstrap";
// core components
import Header from "../../../components/headers/Header";
import LoadingIndicator from "../../../components/ui/LoadingIndicator";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { useForm } from "react-hook-form";

import { Actions, reducer, INITIAL_STATE, ActionTypes } from "../../../redux/screens/admin/homework/EditRedux";
import AuthorizedScreen from "../../../components/base/AuthorizedScreen";
import { NavigationService, NavigateActionTypes } from "../../../navigation";
import UIDs from "../../../UIDs";

const uid = UIDs.screens.admin.homework.edit;

class EditScreen extends AuthorizedScreen {
    get routeName() {
        return uid;
    }

    get reducer() {
        return reducer;
    }

    get actionHandlers() {
        return {
            [ActionTypes.LOAD_SCREEN_VIEW_ASYNC]: { done: null, error: this._handleAsyncActionError },
            [ActionTypes.SAVE_HOMEWORK_ASYNC]: { done: this._handleSaveHomeworkAsyncDone, error: this._handleAsyncActionError }
        };
    }

    localVars = {
        navParams: {}
    };

    constructor(props) {
        super(props);

        this.localVars.navParams = NavigationService.getNavParams(props);
    }

    componentDidMount() {
        super.componentDidMount();

        const { id } = this.localVars.navParams;
        id && this.props.loadScreenViewAsync(id);
    }

    render() {
        const { homework } = this.props.localState;

        return (
            <>
                <Header />
                <Container className="mt--7" fluid>
                    <Row>
                        <div className="col">
                            {this.isActionExecuting(ActionTypes.LOAD_SCREEN_VIEW_ASYNC)
                                ? <LoadingIndicator />
                                : <EditForm
                                    {...this.props}
                                    homework={homework}
                                    onCancel={this._handleCancelEdit}
                                    onSave={this._handleSaveHomework}
                                />
                            }
                        </div>
                    </Row>
                </Container>
            </>
        );
    }

    _handleCancelEdit = () => {
        NavigationService.navigateByAction(this, NavigateActionTypes.BACK);
    }

    _handleSaveHomework = (data) => {
        confirmAlert({
            title: this.props.t("confirmToSave"),
            message: this.props.t("sureToDo"),
            buttons: [
                {
                    label: this.props.t("yes"),
                    onClick: () => {
                        data = { ...data, partnerId: (this.props.partner ? this.props.partner.id : null) }
                        this.props.saveHomeworkAsync(data);
                    }
                },
                {
                    label: this.props.t("no")
                }
            ]
        });
    }

    _handleSaveHomeworkAsyncDone = (action) => {
        const { id } = action.data || {};
        if (id) {
            NavigationService.navigateToPage(this, `/admin/homework/${id}/details`)
        } else {
            this.displayError(this.props.t("invalidHomeworkId"));
        }
    }

    _handleAsyncActionError = (action) => {
        this.displayError(action.error);
    }
}

function EditForm(props) {
    const { homework } = props;
    const { id, description, type } = homework;
    const { register, handleSubmit, errors } = useForm();
    const submitRef = useRef();

    return (
        <Card className="shadow">
            <CardHeader className="bg-white border-0">
                <Row className="align-items-center">
                    <Col xs="8">
                        <h3 className="mb-0">{props.t("homework")}</h3>
                    </Col>
                    <Col className="text-right" xs="4">
                        <Button
                            color="info"
                            onClick={() => submitRef.current.click()}
                            size="sm">
                            {props.t("save")}
                        </Button>&nbsp;
                        <Button
                            color="default"
                            onClick={props.onCancel}
                            size="sm">
                            {props.t("cancel")}
                        </Button>
                    </Col>
                </Row>
            </CardHeader>
            <CardBody>
                <form onSubmit={handleSubmit(props.onSave)}>
                    <input name="id" hidden type="text" className="form-control" defaultValue={id} ref={register} />
                    <div className="pl-lg-4">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("description")}</label>
                                    <input name="description" type="text" className="form-control-alternative form-control" defaultValue={description}
                                        ref={register({ required: true })} />
                                    {errors.description && <span className="text-danger">{props.t("fieldIsRequired")}</span>}
                                </div>
                                <div className="form-group">
                                    <label className="form-control-label">{props.t("type")}</label>
                                    <select name="type" className="form-control-alternative form-control" defaultValue={type} disabled={!!id}
                                        ref={register({ required: true })} >
                                        <option value="1">{props.t("homework")}</option>
                                        <option value="2">{props.t("holiday")}</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                    <input ref={submitRef} type="submit" hidden />
                </form>
            </CardBody>
        </Card>
    );
}

const mapStateToProps = state => {
    return {
        localState: state.screens[reducer.key] ? state.screens[reducer.key] : INITIAL_STATE,
        userId: state.session.userId,
        partner: state.session.partner
    };
};

const mapDispatchToProps = dispatch => {
    return {
        loadScreenViewAsync: id => dispatch(Actions.loadScreenViewAsync(id)),
        saveHomeworkAsync: vo => dispatch(Actions.saveHomeworkAsync(vo)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation(uid)(EditScreen));